import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Subscription, asyncScheduler, fromEvent } from "rxjs";
import { throttleTime } from "rxjs/operators";
import { SOTService } from "../../services";

// Vertical Scroll Component
// InnerContent gets Scrolled if the height of the component is limited
// And a ScrollIndicator
// Also exposes a throttled scrollEvent
// TODO Replace allCurrently not used across SOT to avoid breaking something
// TODO Also supply

@Component({
  selector: "sot-scroller-vertical",
  template: `
    <div class="scroll-content" #scrollContent>
      <ng-content></ng-content>
    </div>
    <div class="scroll-bottom" *ngIf="show_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
    `,
  styles: [`
    :host {
      position: relative;
      height: auto;
      width: auto;
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      align-items: stretch;
    }
    .scroll-content {
      overflow:auto;
      height: inherit;
      width: inherit;
    }
    .scroll-bottom{
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SOTScrollerVerticalComponent implements OnInit, OnDestroy {
  @ViewChild("scrollContent") scrollcontent: ElementRef;

  @Input() throttle: number = 50;

  @Output() scrollEvent = new EventEmitter<Event>();;

  public show_bottom_scroll = false;

  private _scrollSubscription: Subscription;
  private _resizeObserver: any; // ResizeObserver

  public get getScrollElementRef(): ElementRef {
    return this.scrollcontent.nativeElement;
  }

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _sotService: SOTService,
  ) { }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("ProductComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit(): void {
    const me = this;
    const el = me.scrollcontent.nativeElement;

    // start observing for resize product_list_el // todo besser auf ein click reagieren, da es nicht jeden cahnge mitbekommt, nach max-height wird es nicht getriggert
    me._resizeObserver = new (window as any).ResizeObserver(() => {
      this.checkProductListScroll(el);
    });
    me._resizeObserver.observe(el);

    if (el.scrollHeight > el.offsetHeight) {
      me.show_bottom_scroll = true; // show bottom scroll initial
      me.PushChanges();
    }

    // immer binden, da der content dynamisch ist
    // Subscribe to a throttled scrollEvent from ProductList
    // TODO Use cheaper requestAnimationFrame Throttling
    me._scrollSubscription = fromEvent(el, "scroll").pipe(
      throttleTime(me.throttle, asyncScheduler, { leading: true, trailing: true }),
    ).subscribe((e: Event) => {
      if (me.scrollEvent) {
        me.scrollEvent.next(e);
      }
      this.checkProductListScroll(el);
    });
  }

  private checkProductListScroll(el: any) {
    const at_bottom = (el.scrollTop + el.offsetHeight) >= (el.scrollHeight - 5 /*5=bottom_offset*/);
    if (at_bottom === this.show_bottom_scroll) {
      this.show_bottom_scroll = !at_bottom;
      this.PushChanges();
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._scrollSubscription) {
      me._scrollSubscription.unsubscribe();
    }
    if (me._resizeObserver) {
      me._resizeObserver.unobserve(me.scrollcontent.nativeElement);
    }
  }
}
